export interface IProject {
  id?: string;
  name?: string;
  note?: string | null;
  IsDeleted?: boolean;
}

export const defaultValue: Readonly<IProject> = {
  IsDeleted: false,
};
